<template>
    <div class="lay-table">
        <Evtable :header="tableHeader" :actions="action"
                 :params="paramsUrl"
                 :showSearch="false"
                 :showPage="false"
                 :tools="tools"
                 :showQuickSearch="false"
                 url="/wtcp-selftourism/selfDestinationInfo/recommendTravelNotes" action-width="165"
        >
            <template slot="empty">暂无数据！</template>
        </Evtable>
        <!-- 弹层 -->
        <el-dialog
                class="dialog edit-dialog-style"
                title="新增游记"
                :visible.sync="dialogVisible1"
                v-if="dialogVisible1"
                width="900px"
                :before-close="handleClose1"
                :close-on-click-modal="false"
                ref="clears">
            <parkForm :addType="addType"
                      :areaCode="areaCode"
                      :id="id"
                      @doRefresh="handleClose1"
            ></parkForm>
        </el-dialog>
    </div>
</template>

<script>
    import parkForm from '../components/travelCompents/travelCompents'

    export default {
        name:'parkList',
        props: ["areaCode",'id'],
        components:{parkForm},
        data () {
            const that = this
            return {
                paramsUrl: {
                    id:this.id,
                    destinationTypeId:4,
                    size:100
                },
                // 工具栏
                tools: [{
                    name: 'zjytjcs:createT', //添加数据按钮
                    click: function (e,refresh) {
                        that.dialogVisible1 = true;
                        that.refresh = refresh
                    }
                }],
                // 列表数据
                tableHeader: [ {
                    type: "index",
                    align: "center"
                },   {
                    type: 'number',
                    label: '热门指数',
                    prop: 'recommendStar',
                    width: '100',
                    auth: "zjytjcs:p",
                    blur: this.onChangeSort
                },
                    {
                    label: "名称",
                    prop: "title"
                } ],
                datas: [],
                action: [
                    {
                        name: 'zjytjcs:deleteT',
                        click: function (row, refesh) {
                            that.opt.deleteRow(row, refesh, "/wtcp-selftourism/selfDestinationInfo/", that)
                        }
                    }
                ],

                dialogVisible1: false,
                addType:4,
            };
        },
        methods: {
            //弹层关闭
            handleClose1 () {
                // this.$refs['clears'].$children[0].$refs['parkForm'].clear()
                this.refresh();
                this.dialogVisible1 = false;
                this.pageload2 = false;
            },
            onChangeSort(n, o, rowData) {
                let sortUrl = '/wtcp-selftourism/selfDestinationInfo/updateStarById';
                let sortParams = {"id": o.id, "recommendStar": n};
                this.request.putParams(sortUrl, sortParams).then(res => {
                    if (res.status == 1) {
                        this.$message({type: 'success', message: res.msg});
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            },
        },
        created: function () {
            this.request.oprahfun(this);
        },
        computed: {
        },
        watch:{
            // paramsUrl(){
            //
            // }
        }
    };
</script>




